export default __webpack_public_path__ + "180f321e05960ede79bd10a8c7fd5b4f.png";